import { useWatch } from 'react-hook-form';
/* Guarantees that the form data is not undefined,
 * which its not since we define initial values in EventComposer.tsx
 */
export function useSafeFormData() {
    return useWatch();
}
